import { __decorate } from "tslib";
import { singleton } from "tsyringe";
import "../elements/components/toaster.element";
import { ErrorSeverity } from "../enums/error-severity";
let ToasterService = class ToasterService {
    constructor() {
        this._counter = 0;
        // register globally so we can make sure there is only one instance
        globalThis.SeToaster = globalThis.SeToaster || {};
        if (!globalThis.SeToaster.instance)
            this.createToasterElement();
        /*if (document.readyState === "complete") {
            this.createToasterElement();
        } else {
            window.addEventListener("DOMContentLoaded", (event) => {
                this.createToasterElement();
            });
        }*/
    }
    getToasterElement() {
        if (!this._toaster) {
            this.createToasterElement();
        }
        return this._toaster;
    }
    createToasterElement() {
        // if there is no single instance, generate one and append it to end of the document
        if (!globalThis.SeToaster.instance && globalThis.document && globalThis.document.body) {
            globalThis.SeToaster.instance = globalThis.document.createElement("se-toaster");
            globalThis.document.body.appendChild(globalThis.SeToaster.instance);
        }
        this._toaster = globalThis.SeToaster.instance;
    }
    hideToaster() {
        if (!this._toaster)
            this.createToasterElement();
        if (this._toaster) {
            this._toaster.style.left = "-1000px";
            this._toaster.style.top = "-1000px";
        }
    }
    async showNetworkError(err) {
        if (!this._toaster)
            this.createToasterElement();
        if (this._toaster)
            this._toaster.addToast({
                id: this._counter++,
                title: err.severity === ErrorSeverity.Error ? "Error" : "Unexpected Error",
                description: err.message,
                timeout: 0,
                iconColor: "crimson",
                icon: "fas fa-circle-xmark",
            });
    }
    async showUnexpectedError(message) {
        if (!this._toaster)
            this.createToasterElement();
        if (this._toaster)
            this._toaster.addToast({
                id: this._counter++,
                title: "Unexpected Error",
                description: message,
                timeout: 0,
                iconColor: "crimson",
                icon: "fas fa-circle-xmark",
            });
    }
    async showErrorList(messages) {
        if (!this._toaster)
            this.createToasterElement();
        this._toaster.addToast({
            id: this._counter++,
            title: "Unexpected Error",
            descriptions: messages,
            timeout: 0,
            iconColor: "crimson",
            icon: "fas fa-circle-xmark",
        });
    }
    async showError(message, title) {
        if (!this._toaster)
            this.createToasterElement();
        if (this._toaster)
            this._toaster.addToast({
                id: this._counter++,
                title: title ? title : "Error",
                description: message,
                timeout: 0,
                iconColor: "crimson",
                icon: "fas fa-circle-xmark",
            });
    }
    async showSimpleError(err) {
        if (!this._toaster)
            this.createToasterElement();
        this._toaster.addToast({
            id: this._counter++,
            title: err.severity === ErrorSeverity.Error ? "Error" : "Unexpected Error",
            description: err.message,
            timeout: 0,
            iconColor: "crimson",
            icon: "fas fa-circle-xmark",
        });
    }
    async showSuccess(message, timeout = 3000) {
        if (!this._toaster)
            this.createToasterElement();
        if (this._toaster)
            this._toaster.addToast({
                id: this._counter++,
                title: "Success",
                description: message,
                timeout: timeout,
                iconColor: "DarkGreen",
                icon: "fas fa-circle-check",
            });
    }
    async showSuccessTitle(title, message, timeout = 3000) {
        if (!this._toaster)
            this.createToasterElement();
        if (this._toaster)
            this._toaster.addToast({
                id: this._counter++,
                title: title,
                description: message,
                timeout: timeout,
                iconColor: "DarkGreen",
                icon: "fas fa-circle-check",
            });
    }
    async showWarning(message) {
        if (!this._toaster)
            this.createToasterElement();
        if (this._toaster)
            this._toaster.addToast({
                id: this._counter++,
                title: "Warning",
                description: message,
                timeout: 5000,
                iconColor: "DarkOrange",
                icon: "fas fa-circle-exclamation",
            });
    }
    async showInformation(title, message) {
        if (!this._toaster)
            this.createToasterElement();
        if (this._toaster)
            this._toaster.addToast({
                id: this._counter++,
                title: title,
                description: message,
                timeout: 5000,
                iconColor: "DodgerBlue",
                icon: "fas fa-circle-question",
            });
    }
    clear() {
        const toaster = this.getToasterElement();
        toaster.clear();
        this.hideToaster();
    }
};
ToasterService = __decorate([
    singleton()
], ToasterService);
export { ToasterService };
//# sourceMappingURL=toaster.service.js.map